/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const newResourceRequestSchema = z.object({
  name: z.string().min(0).max(255),
});
